import { AxiosPublic } from "../config/axios";

export async function getFrames(query) {
  return await AxiosPublic.get("/frame", { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getOneFrame(id) {
  return await AxiosPublic.get("frame/show/" + id)
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
